import { BaseModel } from './BaseModel';

export interface RemoteTag extends BaseModel {
  name: string;
  description?: string;
  chargePoints?: BaseModel[];
  chargePointsCount?: number;
  label?: string;
}
